import React from "react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const KPI_CONFIG = [
  { key: "compliancePct",      label: "Compliance",          color: "#00ff90", suffix: "%" },
  { key: "late",               label: "Late",                color: "#fbbf24"              },
  { key: "missingPunches",     label: "Missing Punches",     color: "#f87171"              },
  { key: "unplannedAbsences",  label: "Unplanned Absences",  color: "#f87171"              },
  { key: "regOpen",            label: "Reg. Open",           color: "#fb923c"              },
  { key: "regSlaRisk",         label: "Reg. SLA Risk",       color: "#f43f5e"              },
  { key: "overtimeHrs",        label: "Overtime (hrs)",      color: "#60a5fa"              },
  { key: "wfhPct",             label: "WFH",                 color: "#c084fc", suffix: "%" },
];

export default function AttendanceFilters({ filters = {}, setFilters, kpis, loading }) {
  const set = (k, v) => setFilters?.(f => ({ ...f, [k]: v }));

  return (
    <div className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-5 space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        <div>
          <label className={labelCls}>From</label>
          <input type="date" className={inputCls} value={filters.from || ""} onChange={e => set("from", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>To</label>
          <input type="date" className={inputCls} value={filters.to || ""} onChange={e => set("to", e.target.value)} />
        </div>
        {[
          { key: "location",   label: "Location",   opts: ["ALL","London","Bangalore","Remote","New York"] },
          { key: "department", label: "Department",  opts: ["ALL","Engineering","Product","QA","HR","Ops"]  },
          { key: "empType",    label: "Employment",  opts: ["ALL","Full-time","Contract","Intern"]           },
          { key: "shift",      label: "Shift",       opts: ["ALL","Day","Evening","Night"]                  },
        ].map(({ key, label, opts }) => (
          <div key={key}>
            <label className={labelCls}>{label}</label>
            <select className={inputCls} value={filters[key] || "ALL"} onChange={e => set(key, e.target.value)}>
              {opts.map(o => <option key={o} value={o}>{o === "ALL" ? `All ${label}s` : o}</option>)}
            </select>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3 pt-1 border-t border-white/5">
        {KPI_CONFIG.map(({ key, label, color, suffix = "" }) => (
          <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
            {loading || !kpis ? (
              <div className="h-6 rounded bg-white/10 animate-pulse mb-1" />
            ) : (
              <p className="text-lg font-bold" style={{ color }}>
                {kpis[key] != null ? `${kpis[key]}${suffix}` : "—"}
              </p>
            )}
            <p className="text-xs text-white/30 mt-0.5 leading-tight">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}